module.exports = __webpack_public_path__ + "static/media/Government House c.1910.18e3dd03.jpg";